import React, { FC } from "react";
import { Element } from "../../../../models/elementModel";
import { TabModel } from "../../../../models/tabModel";
import TabItemProperties from "./tabItemProperties";

export interface TabListElementPropertiesProps {
  element: Element;
  tabs: TabModel[];
}

const TabListProperties: FC<TabListElementPropertiesProps> = ({
  element,
  tabs,
}) => {

  const renderTabList = () => {
    return tabs.map((tab, i) => {
      return <TabItemProperties tab={tab} />;
    });
  };

  return (
    <div className="">
      <div className="form-group row">
        <label
          htmlFor="img-alt"
          className="col-sm-4 col-form-label font-size-12 align-text-left"
        >
          Tabs
        </label>
      </div>
      {renderTabList()}
    </div>
  );
};

export default TabListProperties;
